"use client";
import * as React from "react";
const SvgExternalFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 15 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.33 8.33v5H1.67V1.67h5V0h-5C.75 0 0 .75 0 1.67v11.66C0 14.25.75 15 1.67 15h11.66c.92 0 1.67-.75 1.67-1.67v-5zm-1.18-6.66H9.1V0H15v5.9h-1.67V2.84l-5.7 5.7-1.17-1.17z" }));
export {
  SvgExternalFilled as default
};
